import {  parsePhoneNumber } from 'awesome-phonenumber';

export const validatePhoneNumber = (phoneNumber, countryCode = 'AU') => {
  try {
    const pn = parsePhoneNumber(phoneNumber, { regionCode: countryCode });
    return {
      isValid: pn.valid,
      formattedNumber: pn.number?.input,
      error: pn.valid ? null : 'Invalid phone number'
    };
  } catch (error) {
    return {
      isValid: false,
      error: 'Invalid phone number format'
    };
  }
};

export const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const isValid = emailRegex.test(email);
  return {
    isValid,
    error: isValid ? null : 'Invalid email format'
  };
};

// Debounce function for API calls
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Address validation is now done on the backend or after place selection
export const validateAddress = async (address) => {
  if (!address) {
    return {
      isValid: false,
      error: 'Address is required',
    };
  }
  return { isValid: true };
};

export const validateABN = (abn) => {
  if (!abn) return { isValid: true };
  
  // Remove all non-numeric characters
  const cleanABN = abn.replace(/\D/g, '');
  
  // ABN must be 11 digits
  if (cleanABN.length !== 11) {
    return {
      isValid: false,
      error: 'ABN must be 11 digits'
    };
  }
  
  // Validate ABN using the checksum algorithm
  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  let sum = 0;
  
  // Subtract 1 from first digit
  const digits = cleanABN.split('').map(Number);
  digits[0]--;
  
  // Calculate weighted sum
  for (let i = 0; i < 11; i++) {
    sum += digits[i] * weights[i];
  }
  
  if (sum % 89 !== 0) {
    return {
      isValid: false,
      error: 'Please enter a valid ABN'
    };
  }
  
  return { isValid: true };
};

export const validateRequired = (value, fieldName) => {
  if (!value || (typeof value === 'string' && !value.trim())) {
    return {
      isValid: false,
      error: `${fieldName} is required`
    };
  }
  return { isValid: true };
}; 